export default {
  input_phone: 'INPUT-PHONE-NUMBER',
  confirm_otp: 'CONFIRM-OTP',
  account_recovery: 'ACCOUNT-RECOVERY',
  in_app_approval: 'IN_APP_APPROVAL',
  face_scan: 'FACE_SCAN',
}
